import axios from 'axios'
import { Message } from 'element-ui'

const spRequest = axios.create({
  baseURL: '/api/admin/service-provider',
  timeout: 15000
})

let unauthorizedHandling = false

function handleUnauthorized(message = '登录已过期，请重新登录') {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_username')
  if (!unauthorizedHandling) {
    unauthorizedHandling = true
    Message.error(message)
    window.location.hash = '#/login'
    setTimeout(() => {
      unauthorizedHandling = false
    }, 2000)
  }
}

spRequest.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

spRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        handleUnauthorized(res.message || '登录已过期，请重新登录')
      } else {
        Message.error(res.message || '请求失败')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      const data = error.response.data || {}
      handleUnauthorized(data.message || '登录已过期，请重新登录')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

// 获取服务商列表
export function getServiceProviderList() {
  return spRequest({
    url: '/list',
    method: 'get'
  })
}

// 获取服务商分页
export function getServiceProviderPage(params) {
  return spRequest({
    url: '/page',
    method: 'get',
    params
  })
}

// 获取服务商详情
export function getServiceProviderById(id) {
  return spRequest({
    url: '/' + id,
    method: 'get'
  })
}

// 创建服务商
export function createServiceProvider(data) {
  return spRequest({
    url: '',
    method: 'post',
    data
  })
}

// 更新服务商
export function updateServiceProvider(id, data) {
  return spRequest({
    url: '/' + id,
    method: 'put',
    data
  })
}

// 删除服务商
export function deleteServiceProvider(id) {
  return spRequest({
    url: '/' + id,
    method: 'delete'
  })
}
